import { render, staticRenderFns } from "./dialog-admin-select-inbox-to-forward-to.vue?vue&type=template&id=7a6a8b56&scoped=true&"
import script from "./dialog-admin-select-inbox-to-forward-to.vue?vue&type=script&lang=js&"
export * from "./dialog-admin-select-inbox-to-forward-to.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6a8b56",
  null
  
)

export default component.exports